import { useEffect } from 'react';
export function usePaymentCardFormFilled({ values = {}, onFormFilled, fieldsToCheck = [], }) {
    useEffect(() => {
        const allFilled = fieldsToCheck.every((field) => values[field] != null && values[field] !== '');
        onFormFilled(allFilled);
    }, [values, onFormFilled]);
}
//# sourceMappingURL=usePaymentCardFormFilled.js.map